<script setup lang="ts">
import type { ApplicationTemplateState } from '../types'

const props = defineProps<{ state: ApplicationTemplateState }>()

const labels: Record<ApplicationTemplateState, string> = {
  draft: 'Draft',
  published: 'Published',
  archived: 'Archived',
}

const classes: Record<ApplicationTemplateState, string> = {
  draft: 'bg-gray-100 text-gray-600',
  published: 'bg-emerald-100 text-emerald-700',
  archived: 'bg-orange-100 text-orange-700',
}
</script>

<template>
  <span class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium" :class="classes[props.state]">
    {{ labels[props.state] }}
  </span>
</template>
